export const financialQuestion = {
  question1: 'How comfortable do you feel about your personal finances?',
  question2:
    'What level of support is available to address your financial wellbeing needs?',
  value1: 65,
  value2: 65,
};
export const professionalQuestion = {
  question1: 'How comfortable do you feel about your professional development?',
  question2:
    'What level of support is available to address your professional wellbeing needs?',
  value1: 65,
  value2: 65,
};
export const physicalQuestion = {
  question1: 'How comfortable do you feel about your physical health',
  question2:
    'What level of support is available to address your physical wellbeing needs?',
  value1: 65,
  value2: 65,
};

export const mentalQuestion = {
  question1: 'How comfortable do you feel about your mental health?',
  question2:
    'What level of support is available to address your mental wellbeing needs?',
  value1: 65,
  value2: 65,
};

export const socialQuestion = {
  question1:
    'How comfortable do you feel with your relationships with your friends and family?',
  question2:
    'What level of support is available to address your social wellbeing needs?',
  value1: 65,
  value2: 65,
};
export const societalQuestion = {
  question1: 'How comfortable do you feel about your contribution to society?',
  question2:
    'What level of support is available to address your societal wellbeing needs?',
  value1: 65,
  value2: 65,
};
